import { Component, OnInit } from '@angular/core';
import { LeaderboardType, PopulationQuery } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-quiz-leaderboard-page',
  templateUrl: './quiz-leaderboard-page.component.html',
  styleUrl: './quiz-leaderboard-page.component.scss',
})
export class QuizLeaderboardPageComponent implements OnInit {
  populations = Populations;
  isKid: boolean;
  LeaderboardType: LeaderboardType;

  constructor(private populationQuery: PopulationQuery) { }

  ngOnInit(): void {
    this.isKid = this.populationQuery.userInPopulation([this.populations.JuniorBluebirds]);
    if (this.isKid) {
      this.LeaderboardType = LeaderboardType.TriviaEntries;
    } else {
      this.LeaderboardType = LeaderboardType.TriviaPoints;
    }
  }
}
